import React from 'react';
import { CreateUser } from '../..';

export const HO_CreateUser = (props) => (
  <CreateUser title='Add New User' headText='Provide information for the new User' managedRole='User' {...props} />
);
